import { GroupDataApp } from 'features/user-group/user-group-list/components/groupListTableHelpers';

export function getTenantId(row: any) {
  return row.id || row.product?.id;
}

export function buildUpdatedRolesForRoleChange(
  groupData: GroupDataApp[],
  tenantId: string,
  newRole: string,
) {
  return groupData.map((roleObj) =>
    roleObj.tenantId === tenantId ? { ...roleObj, role: newRole } : roleObj,
  );
}

export function buildUpdatedRolesForRemoval(
  groupData: GroupDataApp[],
  tenantId: string,
) {
  return groupData.filter((roleObj) => roleObj.tenantId !== tenantId);
}
